module.exports = __webpack_public_path__ + "img/martha-wells.a6bbbbe3.png";